import type React from 'react';
import { useEffect } from 'react';
import './App.scss';
import AppRoutes from './routes/AppRoutes';
const App: React.FC = () => {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
};

export default App;
